import { pick, serverMap } from '@/shared/lib/server-map'
import type { FlowStep } from '@/shared/api'

/**
 * ПРАВИЛО НЕЗНАКОМОГО ЗНАЧЕНИЯ — ОДНО НА ВЕСЬ ФРОНТ.
 *
 * Контракт расширяют раньше, чем перевыпускают фронт, поэтому по проводу приходит не то, что
 * обещают типы. Незнакомое значение НЕ РОНЯЕТ строку и НЕ УТВЕРЖДАЕТ ЛИШНЕГО: оно уезжает в самый
 * консервативный фолбэк — тот, который ничего не обещает. Для шага это `pending`: `done` соврал бы
 * «выполнено», `current` — «идёт прямо сейчас», а `pending` оставляет шаг видимым, ничего о нём не
 * заявляя.
 *
 * ⚠️ Исполнение правила — ровно одно: `serverMap` + `pick` (`shared/lib/server-map`). Там же разбор
 * того, почему литерал `Record<string, X>` с `?? фолбэк` этот инвариант нарушает МОЛЧА.
 *
 * ⚠️ Сборочная защита фолбэку не дублёр: `satisfies Record<FlowStepState, true>` в `BookingFlowCard`
 * роняет сборку, когда НАШ код отстал от контракта, а фолбэк спасает, когда ЖИВОЙ сервер ушёл
 * вперёд от нашей сборки. Разные моменты времени, нужны обе.
 */

export type FlowStepState = FlowStep['state']

// Ключ карты — `string`, а не union контракта: иначе незнакомое значение не прошло бы по типам на
// вход, и фолбэк стал бы мёртвым кодом, защищающим от невозможного. Тип параметра
// `drawableStepState` при этом union — так обещает контракт, — а тело рассчитано на строку вне
// перечисления, и в этом весь смысл.
const DRAWABLE_STATES = serverMap<FlowStepState>({
  done: 'done',
  current: 'current',
  pending: 'pending',
})

/** Одна дверь для КАЖДОГО чтения `FlowStep.state` — иначе незнакомое гасится в одном месте и утекает в другом. */
export function drawableStepState(state: FlowStepState): FlowStepState {
  return pick(DRAWABLE_STATES, state, 'pending')
}
